<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { kenwoodItalyBasicMixin } from "../../modules/kenwood_italy_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, kenwoodItalyBasicMixin],
  data() {
    return {
      errors: [],
      showSpinner: false,
    };
  },
  mounted() { },
  methods: {
    loadFromCSV() {
      this.showSpinner = true;
      const attachment = new FormData();
      attachment.append("attachment", this.$refs.data.files[0]);
      Fandom.ajax({
        url: "/api/v5/new_from_file",
        method: "POST",
        processData: false,
        contentType: false,
        data: attachment,
        success: (data) => {
          setTimeout(() => {
            this.showSpinner = false;
            if (data.content_name) {
              location.href = Fandom.applyContextToUrl(`/easyadmin/content/edit/${data.content_name}`);
            } else {
              this.errors = data.errors
            }
          }, 750);
        },
        complete: () => {
          this.showSpinner = false;
        }
      });
    },
  },
  computed: {}
}
</script>

<template>
  <div v-easyadmin="easyadminId" :id="`ref-${easyadminId}`" :class="contentType" page-import-from-csv>
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10">
          <h1>{{ content.title }}</h1>
          <p v-html="content.description"></p>
          <div class="row align-items-center">
            <div class="col-12 col-md-5">
              <div class="custom-file my-3 mr-3">
                <input type="file" class="custom-file-input" id="file-upload" ref="data" @change="loadFromCSV">
                <label for="file-upload" class="custom-file-label overflow-hidden d-flex">Upload CSV</label>
              </div>
            </div>
            <div v-if="showSpinner" class="col-12 col-md-5">
              <i class="fad fa-spinner fa-spin fa-2x text-primary fa-pulse"></i>
            </div>
            <div v-if="Object.keys(errors).length > 0" class="col-12 col-md-12 pt-3 pb-4 errors">
              <label class="text-xs text-uppercase">{{ft("recipe_ugc.errors.label")}}</label>
              <div class="errors">
                <ul>
                  <li v-for="(error, index) in errors" :key="`error-${index}`" class="d-block">{{error}}</li>
                </ul>
              </div>
            </div>
          </div>
          <p class="mt-5" v-html="content.legend"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[page-import-from-csv] {

  .errors {
    color: $pure-red;
  }
  
}
</style>